import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

export interface TabProps {
  id: string | number;
  title: string;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomTab',
  props: {
    id: {},
    title: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})